import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import StudentListStudentName from '../studentList/StudentListStudentName';
import { StudentListStudent } from '../utils/types';
import { isEmpty } from 'lodash';
import Checkbox from '../SF/Checkbox';
import { formatPhoneNumber } from '../utils/formatter';

export default class IntakeTableRow extends React.Component {

  get rowClass() {
    // attach CSS class with student ID so that automated tests can locate student rows
    return `intake-student student-id-${this.props.student.id}`;
  }

  get studentSelector() {
    return <Checkbox ariaLabel={"Select " + this.props.student.fullName}
                     checked={this.props.studentIsSelected}
                     value={this.props.student.id}
                     onChange={this.props.selectStudent} />
  }

  get studentName() {
    return <StudentListStudentName getStudentFolderLink={this.props.getStudentFolderLink}
                                   id={this.props.student.id}
                                   hasPhoto={this.props.student.hasPhoto}
                                   studentType="student"
                                   studentId={this.props.student.studentId}
                                   name={this.props.student.fullName}
                                   uuid={this.props.student.uuid} />
  }

  get email() {
    return isEmpty(this.props.student.email) ? '' : <a href={`mailto:${this.props.student.email}`}>{this.props.student.email}</a>
  }

  render() {
    return (
      <Table.Row className={this.rowClass}>
        <Table.Cell>{this.studentSelector}</Table.Cell>
        <Table.Cell>{this.studentName}</Table.Cell>
        <Table.Cell className='student-email'>{this.email}</Table.Cell>
        <Table.Cell className='student-cellphone'>{formatPhoneNumber(this.props.student.cellphone)}</Table.Cell>
        <Table.Cell className='student-update-date'>{this.props.student.lastUpdatedDate}</Table.Cell>
      </Table.Row>
    )
  }

}

IntakeTableRow.propTypes = {
  getStudentFolderLink: PropTypes.func.isRequired,
  selectStudent: PropTypes.func.isRequired,
  student: StudentListStudent.isRequired,
  studentIsSelected: PropTypes.bool.isRequired
};
